// removed by extract-text-webpack-plugin
module.exports = {"checkboxIcon":"_2RgMvzZ1U5Dnsr_tlGykC3","input":"_805u-Kh5ZKBoqsNzf-l4_"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/00-atoms/form-elements/checkbox.scss
// module id = 66
// module chunks = 0